import React from 'react'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  .card {
    position: relative;
    width: 100%;
    max-width: 400px;
    min-height: 600px;
    border-radius: 20px;
    z-index: 1111;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 20px 20px 60px rgba(0,0,0,0.3), -20px -20px 60px rgba(255,255,255,0.1);
  }

  .bg {
    position: absolute;
    top: 5px;
    left: 5px;
    right: 5px;
    bottom: 5px;
    z-index: 2;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(24px);
    border-radius: 15px;
    overflow: hidden;
    outline: 2px solid rgba(255, 255, 255, 0.15);
  }

  .blob {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background: linear-gradient(45deg, var(--theme-primary), var(--theme-secondary), var(--theme-accent));
    opacity: 0.2;
    filter: blur(40px);
    animation: blob-bounce 8s infinite ease-in-out;
  }

  @keyframes blob-bounce {
    0% {
      transform: translate(-50%, -50%) translate3d(0, 0, 0);
    }
    25% {
      transform: translate(-50%, -50%) translate3d(100px, -50px, 0);
    }
    50% {
      transform: translate(-50%, -50%) translate3d(-50px, 80px, 0);
    }
    75% {
      transform: translate(-50%, -50%) translate3d(-80px, -30px, 0);
    }
    100% {
      transform: translate(-50%, -50%) translate3d(0, 0, 0);
    }
  }
`;

const GlassCard = ({ children, className = "" }) => {
  return (
    <StyledWrapper className={className}>
      <div className="card">
        <div className="bg" />
        <div className="blob" />
        <div className="relative z-10 w-full p-8">
          {children}
        </div>
      </div>
    </StyledWrapper>
  )
}

export default GlassCard